export default "__VITE_ASSET__CCTqHLSK__"